import { RightClickMenu } from './RightClickMenu';
export default RightClickMenu;
